// yotpo widget loader script
(() => {
  'use strict';
  const scriptTag = document.createElement('script');
  scriptTag.type = "text/javascript";
  scriptTag.src = "https://cdn-widgetsrepository.yotpo.com/v1/loader/vqqItLzAgQdZqUNiyc97Hw";
  scriptTag.async = true;
  let firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(scriptTag, firstScript);
})();
